<template>
  <div v-if="initialized" class="h-screen bg-white flex flex-col items-center justify-center sm:pt-16 sm:pb-8 relative p-2 pb-4 overflow-hidden" style="background: #F1F1F1">
    <div class="bg-white h-screen rounded-2xl sm:rounded-3xl w-full sm:max-w-lg flex flex-col overflow-hidden border border-gray-300 shadow-lg">
      <div v-if="brand" class="border-b border-gray-300 p-4 px-6 text-black font-bold text-xl">
        {{ brand }}
      </div>
      <div class="flex-1 p-6 overflow-y-auto flex flex-col gap-3 bg-white" ref="messagesContainer">
        <div v-for="(message, index) in conversation" :key="index" :class="['flex', message.role === 'user' ? 'justify-end' : 'justify-start']">
          <div
              style="max-width: 80%;word-break: break-word;"
            :class="[
              'px-3 py-2 rounded-2xl text-base leading-relaxed max-w-[80%] w-auto',
              message.role === 'user'
                ? 'bg-black text-white'
                : 'bg-gray-100 '
            ]"
              v-html="nl2br(linkify(message.content))"
          >
          </div>
        </div>
        <div v-if="quickReplies" class="flex flex-wrap gap-2  ">
          <button 
            v-for="(reply, index) in quickReplies"
            :key="index"
            @click="sendQuickReply(reply)"
            class="px-4 py-2 bg-white border border-gray-300 rounded-full cursor-pointer text-sm font-medium transition-all duration-200 shadow-sm text-gray-700 hover:bg-gray-50  hover:-translate-y-0.5 hover:shadow-md active:translate-y-0"
          >
            {{ reply }}
          </button>
        </div>
        <div v-if="completed" class="flex ">
          <div class="text-gray-500 text-sm text-center italic py-2">
            {{ t('conversationCompleted') }}
          </div>
        </div>
        <div >
          <div class="bg-gray-100 rounded-2xl px-3 inline-block" v-if="typing">
            <TypingIndictor />
          </div>
        </div>
      </div>
      <div  class="p-3 border-t border-gray-300 flex gap-2 items-center" v-if="!completed">
        <input 
          v-model="newMessage" 
          @keyup.enter="sendMessage"
          :placeholder="t('typePlaceholder')"
          class="flex-1 px-4 py-2  outline-none"
          type="text"
          autofocus
          :disabled="typing"
        />
        <button @click="sendMessage" :disabled="typing" class="px-4 py-2 bg-black text-white border-none rounded-full cursor-pointer hover:opacity-80 flex items-center justify-center">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.63867 3.48645C2.78448 3.33405 3.01036 3.28945 3.20312 3.37512L18.2031 10.0421C18.3836 10.1224 18.5 10.3016 18.5 10.4991C18.4999 10.6966 18.3836 10.876 18.2031 10.9562L3.20312 17.6222C3.01029 17.7079 2.78447 17.6634 2.63867 17.5109C2.49286 17.3583 2.45835 17.1303 2.55273 16.9415L5.77343 10.4982L2.55273 4.05579C2.45835 3.86702 2.49286 3.63903 2.63867 3.48645ZM6.64257 9.99915H10.5L10.6006 10.0089C10.8285 10.0555 11 10.2575 11 10.4991C10.9998 10.7407 10.8284 10.9418 10.6006 10.9884L10.5 10.9991H6.64257L4.07031 16.1417L16.7676 10.4982L4.07031 4.85461L6.64257 9.99915Z" fill="white"/>
          </svg>
        </button>
      </div>
    </div>
    <div class=" text-gray-500 text-sm font-medium mt-4 sm:mt-8 flex">
      {{ t('poweredBy') }} <a target="_blank" class="ml-2" href="https://trengo.com?utm_source=csat">
      <svg width="103" height="24" viewBox="0 0 103 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M42.262 17.3725C41.0329 17.3725 40.0586 17.032 39.3362 16.3453C38.6139 15.6614 38.2528 14.7793 38.2528 13.6991V9.02359H36.6289V6.58395H38.2528V3.65583L41.2961 3.33203V6.58395H42.9199V9.02359H41.2961V13.2692C41.2961 13.8442 41.4165 14.249 41.66 14.4835C41.9008 14.7179 42.2144 14.8352 42.5979 14.8352C42.7127 14.8352 42.9843 14.7877 43.4099 14.6956L44.0482 16.8673C43.5303 17.2022 42.9339 17.3725 42.262 17.3725Z" fill="#B8BDC1"/>
        <path d="M48.6847 7.76278C49.4574 6.97004 50.3981 6.57367 51.5124 6.57367C51.8652 6.57367 52.2012 6.60158 52.5203 6.6602L52.0444 9.64135C51.6916 9.32593 51.1849 9.15566 50.5269 9.13333C49.7906 9.18357 49.1774 9.71672 48.6847 10.7328V17.3734H45.6526V6.8863L48.6847 6.5625V7.76278Z" fill="#B8BDC1"/>
        <path d="M53.9397 11.9755C53.9397 10.3928 54.4464 9.0948 55.4572 8.08713C56.4679 7.07945 57.7669 6.57422 59.3572 6.57422C60.9446 6.57422 62.2101 7.07945 63.148 8.08713C64.0859 9.0948 64.5563 10.39 64.5563 11.9755V13.0557H57.081C57.1538 13.6307 57.4058 14.0829 57.8397 14.4067C58.2737 14.7305 58.7776 14.8924 59.3572 14.8924C60.3679 14.8924 61.2694 14.6049 62.0645 14.0271L63.7976 15.755C63.0024 16.8352 61.5242 17.3739 59.3572 17.3739C57.7697 17.3739 56.4679 16.8715 55.4572 15.861C54.4436 14.8534 53.9397 13.5582 53.9397 11.9755ZM60.8718 9.54421C60.4379 9.22042 59.9339 9.05852 59.3544 9.05852C58.7748 9.05852 58.2709 9.22042 57.8369 9.54421C57.403 9.86801 57.1874 10.3174 57.1874 10.8952H61.5214C61.5214 10.3174 61.3058 9.86801 60.8718 9.54421Z" fill="#B8BDC1"/>
        <path d="M69.9708 10.5039V17.3734H66.9387V6.8863L69.9708 6.5625V7.54505C70.7016 6.89746 71.5667 6.57367 72.5718 6.57367C73.9437 6.57367 74.9908 6.98678 75.7131 7.81581C76.4354 8.64484 76.7966 9.59669 76.7966 10.6769V17.3734H73.7645V11.4334C73.7645 10.7132 73.5825 10.155 73.2241 9.75859C72.863 9.36222 72.317 9.15287 71.5891 9.13333C70.9563 9.1752 70.4188 9.63298 69.9708 10.5039Z" fill="#B8BDC1"/>
        <path d="M89.5663 6.89801V16.5086C89.5663 18.0215 89.1155 19.2832 88.2112 20.2993C87.3097 21.3153 86.1702 21.8513 84.7983 21.9071L84.1488 21.9713C82.0546 21.9266 80.4308 21.3293 79.2745 20.1792L80.6827 18.5603C81.4779 19.1353 82.441 19.4591 83.5749 19.5317C84.7312 19.5317 85.5123 19.2609 85.921 18.7222C86.3298 18.1834 86.5342 17.5889 86.5342 16.9413V16.4025C85.7251 17.0501 84.7871 17.3739 83.7176 17.3739C82.0574 17.3739 80.8115 16.8882 79.98 15.9169C79.1485 14.9455 78.7341 13.6307 78.7341 11.9755C78.7341 10.3928 79.1849 9.0948 80.0892 8.08713C80.9907 7.07945 82.273 6.57422 83.9332 6.57422C85.1595 6.64679 86.0274 6.97338 86.5342 7.55677V6.57422L89.5663 6.89801ZM86.5342 12.9469V11.1967C86.3886 9.98804 85.6327 9.27903 84.2608 9.06968C82.455 9.13388 81.4807 10.0299 81.3351 11.7577C81.4079 13.7731 82.3822 14.8171 84.2608 14.8896C85.6299 14.6747 86.3886 14.0271 86.5342 12.9469Z" fill="#B8BDC1"/>
        <path d="M92.6851 15.8968C91.6296 14.8417 91.1033 13.5325 91.1033 11.9722C91.1033 10.4034 91.6296 9.0915 92.6851 8.04195C93.7406 6.98962 95.0537 6.46484 96.6271 6.46484C98.2006 6.46484 99.5165 6.98962 100.569 8.04195C101.625 9.09429 102.151 10.4034 102.151 11.9722C102.151 13.5409 101.625 14.8528 100.569 15.9024C99.5137 16.9547 98.2006 17.4795 96.6271 17.4795C95.0537 17.4795 93.7406 16.9519 92.6851 15.8968ZM96.6187 14.864C97.4419 14.864 98.111 14.5877 98.6234 14.0378C99.1357 13.4879 99.3933 12.8012 99.3933 11.9805C99.3933 11.1599 99.1357 10.4732 98.6234 9.91774C98.111 9.36226 97.4391 9.08592 96.6075 9.08592C95.79 9.08592 95.1265 9.36226 94.6141 9.91774C94.1018 10.4732 93.8442 11.1599 93.8442 11.9805C93.8442 12.8012 94.1018 13.4879 94.6141 14.0378C95.1265 14.5905 95.7956 14.864 96.6187 14.864Z" fill="#B8BDC1"/>
        <path d="M15.824 0.1556C-8.14452 2.24911 -0.140088 14.4278 9.06263 19.7816C18.4221 25.2275 22.7785 26.2268 28.1932 17.7857C28.1904 17.7857 39.7925 -1.93791 15.824 0.1556ZM9.82976 11.762C9.82976 10.9888 10.4653 10.3552 11.2408 10.3552H18.3325C19.1081 10.3552 19.7436 10.9888 19.7436 11.762C19.7436 12.5352 19.1081 13.1689 18.3325 13.1689H11.2408C10.4653 13.1716 9.82976 12.538 9.82976 11.762ZM22.7701 17.1912H13.223C12.4475 17.1912 11.812 16.5576 11.812 15.7843C11.812 15.0111 12.4475 14.3775 13.223 14.3775H22.7701C23.5456 14.3775 24.1812 15.0111 24.1812 15.7843C24.1812 16.5576 23.5456 17.1912 22.7701 17.1912ZM22.7701 9.14932H8.92265C8.14712 9.14932 7.51158 8.51568 7.51158 7.74248C7.51158 6.96928 8.14712 6.33564 8.92265 6.33564H22.7701C23.5456 6.33564 24.1812 6.96928 24.1812 7.74248C24.1812 8.51568 23.5456 9.14932 22.7701 9.14932Z" fill="#B8BDC1"/>
      </svg>

    </a>
    </div>
  </div>
</template>

<script>


import TypingIndictor from "@/components/TypingIndictor.vue";
import { translations, getTranslation, getLanguageCode } from "@/translations.js";

export default {
  /* global axios */
  name: 'AiAgent',
  components: {TypingIndictor},
  data() {
    return {
      uuid: '',
      conversation: [],
      completed: false,
      newMessage: '',
      typing: false,
      initialized: false,
      currentLanguage: 'en',
      brand: '',
      scale: null,
    }
  },
  methods: {
    t(key, replacements = {}) {
      return getTranslation(translations, this.currentLanguage, key, replacements);
    },
    setLanguageFromAPI(language) {
      this.currentLanguage = getLanguageCode(language);
    },
    async retryWithBackoff(apiCall, maxRetries = 3, baseDelay = 1000) {
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          return await apiCall();
        } catch (error) {
          console.error(`API call failed (attempt ${attempt}/${maxRetries}):`, error);
          
          if (attempt === maxRetries) {
            throw error; // Re-throw the error on final attempt
          }
          
          // Exponential backoff: 1s, 2s, 4s
          const delay = baseDelay * Math.pow(2, attempt - 1);
          console.log(`Retrying in ${delay}ms...`);
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },
    sendQuickReply(reply) {
      this.newMessage = reply;
      this.sendMessage();
    },
    sendMessage() {
      if (this.typing) return;
      if (this.conversation.length > 1 && this.newMessage.trim() === '') return; // only the first message can be empty
      this.conversation.push({
        role: 'user',
        content: this.newMessage,
      });
      const userMessage = this.newMessage;
      this.newMessage = '';
      this.generateAiResponse(userMessage);
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    async generateAiResponse(userMessage) {
      this.typing = true;
      
      try {
        const response = await this.retryWithBackoff(async () => {
          return await axios.post(process.env.VUE_APP_JOURNEYS_API + '?uuid=' + this.uuid, {
            message: userMessage,
          });
        });

        this.conversation.push({
          role: response.data.assistant,
          content: response.data.aiReply,
          quickReplies: response.data.quickReplies,
        });
        this.completed = response.data.completed;
        if (response.data.scale) {
          this.scale = response.data.scale;
        }
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } catch (error) {
        console.error('Failed to get AI response after retries:', error);
        alert(this.t('errorMessage'));
      } finally {
        this.typing = false;
      }
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      }
    },
    nl2br(text) {
      return text.replace(/\n/g, '<br>');
    },
    linkify(text) {
      return text.replace(/(?<!["'=\]]|\bhref=|\bsrc=)(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi, function (url) {
        const trailingPunctuation = /[.,!?;:)]+$/;
        const match = url.match(trailingPunctuation);
        const cleanUrl = match ? url.slice(0, -match[0].length) : url;
        const trailing = match ? match[0] : '';
        let href = cleanUrl.startsWith('http') ? cleanUrl : 'http://' + cleanUrl;
        return `<a href="${href}" class="underline font-bold" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>${trailing}`;
      });
    },
    updateMetaTags() {
      if (!this.brand) return;

      document.title =  this.t('metaTitle', { brand: this.brand });
    },
  },
  async mounted() {
    let uuid = location.pathname.split('/').pop();
    const urlParams = new URLSearchParams(window.location.search);
    this.uuid = uuid;
    if (!uuid) {
      window.location.href = 'https://trengo.com';
    }

    try {
      const response = await this.retryWithBackoff(async () => {
        return await axios.get(process.env.VUE_APP_JOURNEYS_API + '?uuid=' + uuid);
      });

      this.conversation = response.data.conversation;
      this.completed = response.data.completed;
      this.brand = response.data.brand;
      this.scale = response.data.scale;
      this.setLanguageFromAPI(response.data.language);
      this.initialized = true;
      
      if (this.conversation.length === 1 && urlParams.get('score')) {
        this.newMessage = urlParams.get('score') || '';
        this.sendMessage();
      }

      this.$nextTick(() => {
        this.scrollToBottom();
        this.updateMetaTags();
      });
    } catch (error) {
      console.error('Failed to initialize conversation after retries:', error);
      window.location.href = 'https://trengo.com';
    }
  },
  computed: {
    quickReplies() {
      return this.conversation.length > 0 && this.conversation[this.conversation.length - 1].quickReplies || [];
    },
  }
}

</script>
<style scoped>
body, html {
  background: #F1F1F1;
  height: 100vh;
  overflow-y: hidden;
}
</style>
